import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const phoneExtension = (joi: any) => {
    return {
        type: 'phone',
        base: joi.string(),
        messages: {
            'phone.invalid': 'Invalid',
        },
        validate(value: any, helpers: any) {
            const nonNumeric = /\D/;
            if (nonNumeric.test(value.replace('+', ''))) {
                return { value, errors: helpers.error('phone.invalid') };
            }

            const phoneNumber = parsePhoneNumberFromString(value, 'FR');
            if (!phoneNumber || !phoneNumber.isValid() || phoneNumber.country !== 'FR') {
                return { value, errors: helpers.error('phone.invalid') };
            }
        },
    };
};
